var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.2 38.4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01 0h49.17c1.66.01 3.01 1.37 3.01 3.03v32.33c0 1.67-1.36 3.03-3.03 3.03H3.01C1.35 38.39 0 37.03 0 35.37V3.03C0 1.37 1.35.01 3.01 0z",
    fill: "#ed2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01 0H37.2v38.4H3.02A3.045 3.045 0 010 35.37V3.03C0 1.37 1.35.01 3.01 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01 0H18v38.4H3.02A3.045 3.045 0 010 35.37V3.03C0 1.37 1.35.01 3.01 0z",
    fill: "#002395"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fr.0ed2ae97630c7efc5a6857335a84eaea.svg";